import React from "react";
import { WagmiProvider, http } from "wagmi";
import { mainnet } from "viem/chains";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  RainbowKitProvider,
  getDefaultConfig,
  lightTheme,
  darkTheme,
} from "@rainbow-me/rainbowkit";

const anvilFork = {
  id: 31337,
  name: "Anvil",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["http://127.0.0.1:8548"] },
  },
  contracts: {
    ensUniversalResolver: { address: mainnet.contracts.ensUniversalResolver.address },
  },
};

const isDev = typeof window !== "undefined" && window.location.hostname === "localhost";

const config = getDefaultConfig({
  appName: "Lyre",
  projectId: "placeholder",
  chains: isDev ? [anvilFork, mainnet] : [mainnet],
  transports: {
    [anvilFork.id]: http("http://127.0.0.1:8548"),
    [mainnet.id]: isDev ? http("http://127.0.0.1:8548") : http("https://ethereum-rpc.publicnode.com"),
  },
});

const queryClient = new QueryClient();

const prefersDark =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export default function WalletApp({ children }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          theme={prefersDark ? darkTheme() : lightTheme()}
          initialChain={isDev ? anvilFork : mainnet}
        >
          {children}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
